import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import Modal from "../../../../components/ui/Modal/Modal";
import { SaveIcon } from "../../../../assets/icons";

export default function REFTable({ data, onDownload }) {
  const navigate = useNavigate();

  const handleDetail = (id) => {
    navigate(`${id}`);
  };

  const table = {
    header: [
      {
        id: 1,
        title: "번호",
      },
      {
        id: 2,
        title: "상품명",
      },
      {
        id: 3,
        title: "REF(상품코드)",
      },
      {
        id: 4,
        title: "등록 QR 수",
      },
      {
        id: 5,
        title: "최종 업데이트일",
      },
      {
        id: 6,
        title: "관리",
      },
    ],
  };
  return (
    <>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className="p-2 bg-[#f2f2f4] border border-[#dddddd]"
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {
              data?.map((val, index) => {
                const indexVal = data?.length - index;
                return (
                  <tr key={val?.id}>
                    <td className="p-2 border border-[#dddddd]">{indexVal}</td>
                    <td className="p-2 border border-[#dddddd] w-[400px]">
                      {val?.name}
                    </td>
                    <td className="p-2 border border-[#dddddd]  w-[300px]">
                      {val?.ref}{" "}
                    </td>
                    <td className="p-2 border border-[#dddddd]">
                      {val?.qrQty ? (
                        val?.qrQty === "0" ? (
                          <span className="text-[#FF0000]">0</span>
                        ) : (
                          <span>{val?.qrQty}</span>
                        )
                      ) : (
                        <span className="text-[#FF0000]">0</span>
                      )}
                    </td>
                    <td className="p-2 border border-[#dddddd]">
                      {val?.updatedAt
                        ? dayjs(val?.updatedAt).format("YYYY-MM-DD")
                        : "-"}
                    </td>

                    <td className="p-4 w-28 border border-[#dddddd]">
                      <button
                        onClick={() => handleDetail(val?.id)}
                        className="w-10 p-[1.5px] border border-[#cccccc] rounded-[4px] text-[#333333]"
                      >
                        상세
                      </button>
                    </td>
                  </tr>
                );
              })
              // .reverse()
            }
          </tbody>
        </table>
      </div>
      <p className="mt-[6px] text-[10px] text-[#767676]">
        ※ REF 관리 메뉴에서는 '상품 그룹명'에 등록 된 상품을 REF 단위로 정보를
        볼 수 있습니다. REF의 LOT 신규 등록 및 스마트팩토리 재고 연동은 '상세'를
        선택해주세요.
      </p>
      <div className="mt-8 flex justify-end overflow-auto w-full">
        {/* <Pagination
          total={1}
          page={0}
          isDisabledPrevPage={false}
          isDisabledNextPage={false}
          onPrevClick={() => {}}
          onNextClick={() => {}}
          onChange={() => {}}
        /> */}
        <div className="flex-none">
          <Modal
            hasCancel={false}
            description="다운로드 되었습니다."
            onSubmit={() => {}}
          >
            <button
              onClick={onDownload}
              className="py-[6px] px-[8px] border border-[#cccccc] rounded-[4px] text-[#333333]"
            >
              <div className="flex items-center gap-2">
                <SaveIcon />
                엑셀 저장
              </div>
            </button>
          </Modal>
        </div>
      </div>
    </>
  );
}
